import React from 'react'
import parse from 'html-react-parser'
import ClickSearchForm from './click-search-form'
import useForSaleQuery from "../hooks/use-for-sale-query"
import useAgentsQuery from "../hooks/use-agents-query"
import useSoldQuery from "../hooks/use-sold-query"
import useLeaseQuery from "../hooks/use-lease-query"
import useForSaleCommercialQuery from '../hooks/use-for-sale-commercial-query'
import useSoldCommercialQuery from '../hooks/use-sold-commercial-query'
import useLeaseCommercialQuery from '../hooks/use-lease-commercial-query'

const HomeBanner = ({ title, video }) => {

  const staff = useAgentsQuery()
  const forSale = useForSaleQuery()
  const sold = useSoldQuery()
  const lease = useLeaseQuery()
  const commercialSale = useForSaleCommercialQuery()
  const commercialSold = useSoldCommercialQuery()
  const commercialLease = useLeaseCommercialQuery()

  return (
    <section className='home-banner'>
      <div className='home-banner__inner'>
        { title && <h1>{ parse(title) }</h1> }
        <ClickSearchForm staff={staff} forSale={forSale} sold={sold} lease={lease} home={true} commercialSale={commercialSale} commercialSold={commercialSold} commercialLease={commercialLease} />
      </div>
      { video &&
      <div className='home-banner__video'>
        <video src={ video } autoPlay muted loop playsInline/>
      </div>
      }
    </section>
  )
}

export default HomeBanner